export function applyPlayerOptions(player, playerOptions) {
    for (const [pluginKey, pluginOptions] of Object.entries(playerOptions)) {
        if (player[pluginKey]) {
            if (typeof pluginOptions === 'object') {
                const plugin = player[pluginKey]();
                for (const [optionKey, optionValue] of Object.entries(pluginOptions)) {
                    if (optionValue !== undefined) {
                        plugin[optionKey] = optionValue;
                    }
                }
            }
            else {
                player[pluginKey]?.(pluginOptions);
            }
        }
        else {
            if (pluginOptions) {
                console.warn(`Plugin or option "${pluginKey}" doesn't exist. Custom options that were passed for this plugin or option will be ignored.`);
            }
        }
    }
}
